import {
  customerItems,
  customerCreate
} from '@/api/customer'

const customer = {
  state: {

  },
  mutations: {

  },
  actions: {
    CustomerItems ({ commit }, data) {
      return new Promise((resolve, reject) => {
        customerItems(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    CustomerCreate ({ commit }, data) {
      return new Promise((resolve, reject) => {
        customerCreate(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}
export default customer



// WEBPACK FOOTER //
// ./src/store/modules/customer.js